import { Box } from "@mui/material";
import PropTypes from "prop-types";

export default function TextViewer({ page }) {
    if (!page) {
        return (
            <Box sx={{ p: 2, color: "#94a3b8" }}>
                No page selected
            </Box>
        );
    }

    return (
        <Box
            component="textarea"
            value={page.text_content || ""}
            readOnly
            dir="rtl"
            sx={{
                width: "100%",
                height: "100%",
                resize: "none",
                border: "none",
                outline: "none",
                p: 2,
                fontFamily: "inherit",
                fontSize: 18,
                lineHeight: 1.8,
                color: "#1e293b",
                background: "#fff",
                boxSizing: "border-box",
                direction: "rtl",
                unicodeBidi: "plaintext",
            }}
        />
    );
}

TextViewer.propTypes = {
    page: PropTypes.object,
};